import RequesterV1 from "@/components/api/v1/requester.js";

export default {

  fetchAgroExporterProcesses(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_agro_exporter_processes/${harvest_process_id}`
    );
  },

  fetchPackingHouseProcesses(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_packing_house_processes/${harvest_process_id}`
    );
  },

  fetchPackingLines(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_packing_lines/${harvest_process_id}`
    );
  },

  fetchOrganizationCropField(organization_id, crop_field_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_organization_crop_field/${crop_field_id}`
    );
  },

  fetchCurrencies(organization_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_currencies`
    );
  },

  fetchExporterProcessBrands(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_exporter_process_brands/${agro_exporter_process_id}`
    );
  },

  destroy(organization_id, exported_batch_id) {
    return RequesterV1.delete(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/destroy/${exported_batch_id}`
    );
  },

  fetchExporterProcessCropPackages(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_exporter_process_crop_packages/${agro_exporter_process_id}`
    );
  },

  fetchExporterProcessCropCategories(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_exporter_process_crop_categories/${agro_exporter_process_id}`
    );
  },

  fetchExporterProcessCropVarieties(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_exporter_process_crop_varieties/${agro_exporter_process_id}`
    );
  },

  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },

  fetchExporterProcessCropSizes(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_exporter_process_crop_sizes/${agro_exporter_process_id}`
    );
  },

  fetchExportedBatch(organization_id, exported_batch_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_exported_batch/${exported_batch_id}`
    );
  },

  update(organization_id, harvest_process_id, exported_batch_id, exported_batch) {
    return RequesterV1.post(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/update/${harvest_process_id}/${exported_batch_id}`,
      {exported_batch: exported_batch}
    );
  },

  create(organization_id, harvest_process_id, exported_batch) {
    return RequesterV1.post(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/create/${harvest_process_id}`,
      {exported_batch: exported_batch}
    );
  },

  fetchProducers(organization_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_producers`
    );
  },

  fetchCropFields(organization_id, harvest_process_id, producer_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_exported_batch/${organization_id}/fetch_crop_fields/${harvest_process_id}/${producer_id}`
    );
  },

}
